export const NO_ADDITIONAL_FIELDS_TEXT = 'There are no additional fields to add';
